import api from 'api'

export const updateConclusionMessage = async (id, payload) => {
  const { data } = await api.put(`/form/conclusion-message/${id}`, payload)

  return data
}